import React from 'react';

import {
  Breadcrumb,
  Helmet,
  Sidebar,
  SidebarPage,
  SidebarPageContainer,
} from 'fr-shared/components';
import { useTableFilters } from 'fr-shared/hooks';

import CostingSearch from './components/CostingSearch';
import CostingSidebar from './components/CostingSidebar';
import CostingTable from './components/CostingTable';
import {
  CLOSED_COLUMNS,
  FILTER_FIELDS,
  INITIAL_CLOSED_FILTERS,
  INITIAL_CLOSED_SORT,
  getClosedCostingRequests,
} from './utils/queues';

const FILTER_NAME = 'costing_closed';
const FIELDS = [
  FILTER_FIELDS.SalesContactId,
  FILTER_FIELDS.ManufacturingProcessId,
  FILTER_FIELDS.EngineeringContactId,
  FILTER_FIELDS.SupportContactId,
];

const CostingClosedQueue = () => {
  const {
    data: costingRequests,
    filters,
    loading,
    handleSearch: handleTextSearch,
    onFetchData: handleTableFetchData,
    pages,
    resetFilters,
    setFilters,
  } = useTableFilters(FILTER_NAME, INITIAL_CLOSED_FILTERS, getClosedCostingRequests);

  return (
    <>
      <Helmet title="Closed Queue" />
      <Breadcrumb to="/admin/costing_requests">Costing Requests</Breadcrumb>
      <Breadcrumb to="/admin/costing_requests/closed_queue">Closed Queue</Breadcrumb>

      <SidebarPageContainer localStorageKey={Sidebar.LOCAL_STORAGE_KEYS.costing_closed}>
        <SidebarPage>
          <div className="page-header flex mb-0 px-3">
            <h2>Closed Queue</h2>
            <CostingSearch
              filters={filters}
              setFilters={setFilters}
              onTextSearch={handleTextSearch}
            />
          </div>

          <CostingTable
            columns={CLOSED_COLUMNS}
            data={costingRequests}
            emptyText="No Requests are currently closed"
            loading={loading}
            onFetchData={handleTableFetchData}
            pages={pages}
            sort={INITIAL_CLOSED_SORT}
          />
        </SidebarPage>

        <Sidebar>
          <CostingSidebar
            fields={FIELDS}
            filters={filters}
            resetFilters={resetFilters}
            setFilters={setFilters}
          />
        </Sidebar>
      </SidebarPageContainer>
    </>
  );
};

export default CostingClosedQueue;
